import { useState, useEffect, useCallback } from "react";

// Optimized responsive hook that uses a single event listener
export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState(() => {
    if (typeof window === "undefined") return { isMobile: false, isLgUp: false };
    
    const width = window.innerWidth;
    return {
      isMobile: width <= 768,
      isLgUp: width >= 1400,
    };
  });

  const handleResize = useCallback(() => {
    const width = window.innerWidth;
    setScreenSize({
      isMobile: width <= 768,
      isLgUp: width >= 1400,
    });
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Use ResizeObserver if available, fallback to resize event
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(document.body);
      return () => resizeObserver.disconnect();
    } else {
      window.addEventListener("resize", handleResize, { passive: true });
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [handleResize]);

  return screenSize;
};

// Optimized loading hook
export const usePageLoading = () => {
  const [isLoading, setIsLoading] = useState(() => {
    if (typeof window === "undefined") return true;
    return document.readyState !== "complete";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (document.readyState === "complete") {
      setIsLoading(false);
      return;
    }

    const handleLoad = () => setIsLoading(false);
    
    window.addEventListener("load", handleLoad, { once: true });
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return isLoading;
}; 